export let base = window.location.origin;
if (base === 'https://consumer.servisor.co.za') {
    base = 'https://api-servisor.injozitech.com';
} else {
    base = 'https://api-servisor-staging.injozitech.com';
}

// Testing
// const TESTING_WORKSHOP_URL =
//   "https://servisor-staging.injozitech.com/api/v1/servisor/consumer";

// locally
//    export const TESTING_WORKSHOP_URL = `${baseLocal}/api/v1/servisor/consumer`;

//prod
export const TESTING_WORKSHOP_URL = `${base}/api/v1/servisor/consumer`;

export const getAllActiveWorkshops = async () => {
    try {
        const response = await fetch(
            `${TESTING_WORKSHOP_URL}/get_active_workshops`,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                },
            }
        );

        if (response.ok) {
            return await response.json();
        } else {
            const errorResponse = await response.json();
            throw errorResponse;
        }
    } catch (error) {
        throw error;
    }
};

export const getSelectedWorkshopById = async (id: string) => {
    try {
        const response = await fetch(
            `${TESTING_WORKSHOP_URL}/get_active_workshop_by_id/${id}`,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                },
            }
        );

        if (response.ok) {
            return await response.json();
        } else {
            const errorResponse = await response.json();
            throw errorResponse;
        }
    } catch (error) {
        throw error;
    }
};
